<template>
  <div class="my_div">
    <div class="title">
      <slot class="back-image" name="back"></slot>
      <slot name="title"></slot>
    </div>
    <div class="cancel">
      <slot name="cancel"></slot>
    </div>
    <div class="create">
      <slot name="create"></slot>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style scoped>
.my_div{
  display: flex;
  flex-direction: row;
  height: 72px;
  box-shadow: 0 10px 10px -5px #E6E6E1;
}
.title {
  margin-left: 45px;
  font-size: 24px;
}
::v-deep .title label {
  display: block;
  white-space: nowrap;
  width: 700px;
  overflow: hidden;
  line-height: 72px;
  text-overflow: ellipsis;
}
.cancel{
  text-align: right;
  margin-right: 16px;
  flex: 1;
  line-height: 72px;
}
.create{
  min-width: max-content;
  line-height: 72px;
  padding-right: 20px;
}

</style>
